import React from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import { PageSelectContent, PagesList, ListItem, Button } from "./styles";

const PageSelectList = ({ pages, showModal }) => (
  <PageSelectContent>
    <PagesList>
      {pages.map(page => (
        <ListItem key={page.id}>
          <a href={`https://prosite.alboompro.com/content/pages/${page.id}`}>
            {page.name}
          </a>
        </ListItem>
      ))}
    </PagesList>
    <Button onClick={showModal}>
      <img
        src="http://icons.alboompro.com/v1/bold/interface-essential/remove-add/ffffff/add.svg"
        alt=""
        width="10"
      />
      <span>{I18n.t("header.pageSelect.button")}</span>
    </Button>
  </PageSelectContent>
);

const mapDispatchToProps = {};

const mapStateToProps = state => {
  return {
    pages: state.header.pages
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PageSelectList);
